export default __webpack_public_path__ + "static/media/arrow-next.40981ad7.svg";